module.exports = __webpack_public_path__ + "static/media/bg.f7b2e00a.jpg";